import React, { FC } from 'react';
import { styles, TextLink, SdiLicense, SdiReport } from '@sdir/sds';
import styled from 'styled-components';
import moment from 'moment';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetOwnEndorsementsGetOwnEndorsementsDto as EndorsementDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { useIntl } from 'react-intl';
import { CapitalizeString } from '../../../helpers/Certificates';

export interface EndorsementTileProps {
  data: EndorsementDto;
  onOpenEndorsement: (endorsement: any) => void;
  onOpenDispensation: (dispensation: any) => void;
}

export const EndorsementTile: FC<EndorsementTileProps> = ({
  data,
  onOpenEndorsement,
  onOpenDispensation,
}) => {
  const intl = useIntl();
  const endorsementName = CapitalizeString(data?.endorsement?.title || '');
  const date = data?.endorsement?.issuedAt || '';

  return (
    <TileBody>
      <Header>
        <CalssificationContainer>
          <p className="certificatetitle">{endorsementName}</p>
        </CalssificationContainer>
        <DateContainer>
          <p>{intl.formatMessage({ id: 'endorsements.page.issued' })}</p>
          <p>{date && moment(date).format('DD.MM.YYYY')}</p>
        </DateContainer>
      </Header>
      <Footer>
        {data?.endorsement && (
          <TextLink
            text={intl.formatMessage({ id: 'endorsements.page.endorsement' })}
            icon={<SdiLicense color={styles.colors.primary} size="s" />}
            onClick={() => onOpenEndorsement(data?.endorsement)}
          />
        )}
        {data?.dispensation && (
          <TextLink
            text={intl.formatMessage({ id: 'endorsements.page.dispensation' })}
            icon={<SdiReport color={styles.colors.primary} size="s" />}
            onClick={() => onOpenDispensation(data?.dispensation)}
          />
        )}
      </Footer>
    </TileBody>
  );
};

const DateContainer = styled.div`
  text-align: end;
  p:first-child {
    font-size: 14px;
    color: ${styles.colors.font.text85};
  }
`;

const CalssificationContainer = styled.div`
  .certificatetitle {
    font-weight: bold;
  }
  p:nth-child(2) {
    color: ${styles.colors.font.text85};
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: start;
  p {
    margin: 0;
    line-height: 1.1;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  p {
    margin: 0;
    line-height: 1.1;
  }
`;

const TileBody = styled.div`
  display: grid;
  align-items: center;
  position: relative;
  width: 352px;
  height: 136px;
  padding: 24px;
  box-shadow: ${styles.card.boxShadow};
  border-radius: ${styles.card.borderRadius};
  background-color: ${styles.colors.alert.successLight};

  @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
    width: 100%;
  }
`;
